/**
 * Admin Moderation Feature - Model
 * 
 * Elm-ish architecture: Typed state for the admin moderation/review queue.
 * 
 * Security note: This feature handles admin review of content.
 * No sensitive identity data should be exposed to admin users without proper authorization.
 */

export interface ModerationItem {
  /** Unique identifier for the item being moderated */
  id: string;
  /** Type of content being reviewed */
  itemType: 'profile' | 'intro_request' | 'report';
  /** Summary or preview of the item (identity-minimized) */
  preview: string;
  /** Reason for moderation flag (if applicable) */
  reason?: string;
  /** When the item was submitted/flagged */
  createdAt: string;
}

export interface AdminModerationModel {
  /** Queue of items awaiting moderation */
  queue: ModerationItem[];
  /** Currently selected item for review */
  selectedItem: ModerationItem | null;
  /** Whether queue is being loaded */
  loading: boolean;
  /** Error message if loading failed */
  error: string | null;
  /** Pending action state for approve/reject */
  pendingAction: 'approve' | 'reject' | null;
  /** Whether action was successful */
  actionSuccess: boolean;
  /** Current page for pagination */
  page: number;
  /** Whether more items are available */
  hasMore: boolean;
}

export const initialModel: AdminModerationModel = {
  queue: [],
  selectedItem: null,
  loading: false,
  error: null,
  pendingAction: null,
  actionSuccess: false,
  page: 1,
  hasMore: false,
};